import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { AssortmentCalculator } from '@infrastructure/assortment-calculator';
import { SubscribingComponent } from '@infrastructure/subscribing-component';
import { AssortmentModel } from '@models/assortment-model';
import { TranslatePipe } from '@ngx-translate/core';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';
import { UserService } from '@services/user.service';
import { combineLatest } from 'rxjs';

@Component({
	selector: "app-first-time-delivery",
	templateUrl: 'first-time-delivery.component.html',
	styleUrls: ['./first-time-delivery.component.scss'],
	imports: [CommonModule, TranslatePipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true
})
export class FirstTimeDeliveryComponent extends SubscribingComponent implements OnInit {
	@Input() model: Array<AssortmentModel | undefined>;
	@Input() inline: boolean = false;

	public missingAssortments: boolean;

	constructor(private orderOnBehalfService: OrderOnBehalfService, private userService: UserService) {
		super();
	}

	ngOnInit() {
		this.subscriptions.push(combineLatest([this.orderOnBehalfService.customerAsObservable(), this.userService.currentUser]).subscribe(([customer, user]) => {
			this.missingAssortments = AssortmentCalculator.FindMissingAssortments(this.model, customer ? customer.Assortments : user?.Assortments).length > 0;
		}));
	}
}
